var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import React from 'react'
import styled from 'styled-components'
var Row = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n'],
      ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n']
    ))
)
export var ODRow = function (props) {
  var children = props.children,
    style = props.style
  return React.createElement(Row, { style: style }, children)
}
var templateObject_1
//# sourceMappingURL=ODRow.js.map
